
import React, { useEffect } from "react";
import Header from "../components/NavBar";
import Footer from "../components/Footer";

export default function Politicas(){
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return(
        <div>
            <Header/>
            <div className="p-5 md:p-20 md:pb-0" >
                <hr/>
                <div className="text-xl md:p-10 font-bold pb-0" >
                    POLITICAS DE TRATAMIENTO DE DATOS PERSONALES
                </div>

                <div  className="ml-10 mt-5">
                    <strong>Financiamos Su Máquina S.A.S.</strong> recopila y trata datos personales a través del acceso, navegación y uso de los sitios web <a className="font-bold" href="www.finmaq.com.co/">www.finmaq.com.co</a>, <a className="font-bold" href="www.go.finmaq.com.co">www.go.finmaq.com.co</a>, así como a través de la aplicación móvil Finmaq Comerciales y del diligenciamiento del Formulario de Vinculación Comercial para acceder a los productos que ofrece en desarrollo de su actividad social.
                 </div>

                <div className="ml-10 mt-5">
                    <strong>FinMaq</strong> pone a disposición de los diferentes grupos de interés las presentes Políticas en virtud de las cuales se proporciona de manera transparente y sencilla toda la información relativa al tratamiento que realizará de sus datos personales, las finalidades para las cuales los tratamos y los derechos que pueden ejercer los titulares.
                </div>
                
                <div className="ml-10 mt-5">
                    Los datos personales obtenidos en virtud de las relaciones comerciales y/o contractuales que se soliciten o celebren con <strong>FinMaq</strong>, serán tratados conforme a los principios y deberes definidos en la Ley 1581 de 2012 y demás normas que traten y regulen esta materia.
                </div>


                <div className="ml-10 mt-5">
                    Para todos los fines pertinentes, <strong>FinMaq</strong> es la RESPONSABLE del tratamiento de los datos personales, con domicilio principal en la <strong>Carrera 10 # 97a - 13 Bogotá D.C.</strong>; Celular <strong>321 241 8543</strong>, página corporativa <a className="font-bold" href="www.finmaq.com.co">www.finmaq.com.co</a> y correo electrónico: <a className="font-bold" href="mailto:protecciondedatos@finmaq.com.co">protecciondedatos@finmaq.com.co</a>.
                </div>

                <div className="text-xl md:p-10 font-bold pb-0" >
                    DESTINATARIOS.
                </div>

                <div className="ml-10 mt-5">
                    Esta política se aplicará a todas las bases de datos tanto físicas como digitales, que contengan datos personales y que sean objeto de Tratamiento por parte de <strong>FinMaq</strong>, las cuales están dirigidas a todas las personas naturales o jurídicas con las cuales pretenda establecer o tenga relaciones comerciales y/o contractuales.
                </div>

                <div className="text-xl md:p-10 font-bold pb-0" >
                    PRINCIPIOS RECTORES.
                </div>

                <div className="ml-10 mt-5">
                    En el desarrollo, interpretación y aplicación de la ley, regulaciones, y normatividad vigente, se aplicarán, de manera armónica e integral, los siguientes principios:
                </div>

                <div className="ml-16 mt-5">
                    <b>A)</b> Principio de Legalidad: en Materia de Tratamiento de Datos: El Tratamiento es una actividad reglada que debe sujetarse a lo establecido en la Ley 1581 del 17 de octubre de 2012, decretos reglamentarios y demás disposiciones que la desarrollen.
                </div>    

                <div className="ml-16 mt-5">
                    <b>B)</b>Principio de Finalidad: El Tratamiento debe obedecer a una finalidad legítima de acuerdo con la Constitución y la Ley, la cual debe ser informada al Titular.
                </div>      

                <div className="ml-16 mt-5">
                    <b>C)</b> Principio de Libertad: El Tratamiento sólo puede ejercerse con el consentimiento, previo, expreso e informado del Titular. Los datos personales no podrán ser obtenidos o divulgados sin previa autorización, o en ausencia de mandato legal o judicial que releve el consentimiento.
                </div>

                <div className="ml-16 mt-5">
                    <b>D)</b> Principio de Veracidad o Calidad: La información sujeta a Tratamiento debe ser veraz, completa, exacta, actualizada, comprobable y comprensible. Se prohíbe el Tratamiento de Datos parciales, incompletos, fraccionados o que induzcan a error.
                </div>

                <div className="ml-16 mt-5">
                    <b>E)</b> Principio de Transparencia: En el Tratamiento debe garantizarse el derecho del Titular a obtener en cualquier momento y sin restricciones, información acerca de la existencia de datos que le conciernan.
                </div>

                <div className="ml-16 mt-5">
                    <b>F)</b> Principio de Acceso y Circulación Restringida: El Tratamiento se sujeta a los límites que se derivan de la naturaleza de los datos personales, de las disposiciones de la ley y la Constitución.
                </div>

                <div className="ml-16 mt-5">
                    <b>G)</b> Principio de Seguridad: La información sujeta a Tratamiento, se deberá manejar con las medidas técnicas, humanas y administrativas que sean necesarias para otorgar seguridad a los registros evitando su adulteración, pérdida, consulta, uso o acceso no autorizado o fraudulento. <strong>FinMaq</strong> se compromete a implementar y mantener medidas de seguridad pertinentes y documentadas, adaptadas a la evolución de los riesgos, incluyendo controles como el cifrado de información, gestión de accesos y planes de gestión de vulnerabilidades, las cuales serán verificables por las autoridades competentes.
                </div>

                <div className="ml-16 mt-5">
                    <b>H)</b> Principio de Confidencialidad: Todos los empleados y terceros que intervengan en el Tratamiento de Datos Personales que no tengan la naturaleza de públicos están obligadas a garantizar la reserva de la información, inclusive después de finalizada su relación con alguna de las labores que comprende el Tratamiento.
                </div>

                <div className="ml-16 mt-5">
                    <b>I)</b> Principio de temporalidad: Los datos personales se conservarán únicamente por el tiempo razonable y necesario para cumplir las finalidades que justificaron el tratamiento, atendiendo a las disposiciones aplicables a la materia de que se trate y a los aspectos administrativos, contables, fiscales, jurídicos e históricos de la información.
                </div>

                <div className="ml-16 mt-5">
                    <b>J)</b> Interpretación integral de los derechos constitucionales: Los derechos se interpretarán en armonía y en un plano de equilibrio con el derecho a la información y con los demás derechos constitucionales aplicables.
                <div className="ml-16 mt-5">

                </div>
                    <b>K)</b> Principio de Necesidad: Los datos personales tratados deben ser los estrictamente necesarios para el cumplimiento de las finalidades perseguidas con la base de datos. <strong>FinMaq</strong> aplicará criterios estrictos para minimizar el tratamiento de datos personales, limitándose a aquellos que sean idóneos y absolutamente necesarios para cumplir las finalidades informadas al titular. En ningún caso se accederá a funcionalidades del dispositivo del titular, como la galería de imágenes o la lista de contactos, para finalidades que no hayan sido explícitamente autorizadas para la prestación del servicio.
                </div>

                
                <div className="text-xl md:p-10 font-bold pb-0" >
                    DATOS SENSIBLES
                </div>

                <div className="ml-10 mt-5">
                    Se entiende por datos sensibles aquellos que afectan la intimidad del Titular o cuyo uso indebido puede generar su discriminación, tales como aquellos que revelen el origen racial o étnico, la orientación política, las convicciones religiosas o filosóficas, la pertenencia a sindicatos, así como los datos relativos a la salud, a la vida sexual y los datos biométricos.
                </div>

                <div className="ml-10 mt-5 font-bold">
                    Autorización especial de datos personales sensibles:
                </div>

                <div className="ml-16 mt-5">
                    <strong>FinMaq</strong> informará que en virtud de la ley 1581 de 2012, el titular no está obligado a otorgar la autorización para el tratamiento de datos sensibles. Los datos sensibles biométricos tratados tienen como finalidad la identificación de las personas, la seguridad, la prevención de fraude y la adecuada prestación de los productos. Su tratamiento requiere una diligencia reforzada, por lo cual <strong>FinMaq</strong> se compromete a:
                </div>

                <div className="ml-24 mt-5">
                    - Informar al titular de manera específica las finalidades precisas para las cuales se tratarán sus datos biométricos.
                </div>

                <div className="ml-24 mt-5">
                    - Obtener del titular la autorización explícita y separada para su recolección y tratamiento.
                </div>

                <div className="ml-24 mt-5">
                    - Implementar medidas de seguridad adicionales y reforzadas para garantizar su protección.
                </div>

                <div className="ml-24 mt-5">
                    - Abstenerse de compartirlos con terceros o de alimentar bases de datos centralizadas, salvo instrucción expresa y legal del responsable.
                </div>

                <div className="ml-24 mt-5">
                    - Suprimir los datos biométricos en un término razonable una vez haya terminado la relación contractual.
                </div>

                <div className="text-xl md:p-10 font-bold pb-0" >
                    TRATAMIENTO Y FINALIDADES.
                </div>

                <div className="ml-10 mt-5">
                    De acuerdo con lo establecido en la Ley 1581 de 2012, FinMaq realizará operaciones que incluyen recolección de datos, su almacenamiento, uso, circulación y/o supresión, exclusivamente para las finalidades autorizadas por el titular.
                </div>

                <div className="ml-10 mt-5">
                    Cuando se utilice la información de los titulares para la toma de decisiones basadas única y exclusivamente en el tratamiento automatizado de sus datos personales, que produzcan efectos jurídicos o le afecten significativamente, el titular tendrá derecho a solicitar y obtener de <strong>FinMaq</strong> una explicación sobre la lógica y criterios principales utilizados en dicha decisión. <strong>FinMaq</strong> implementará los mecanismos para garantizar este derecho.
                </div>

                <div className="ml-10 mt-5">
                    Así mismo y en ejecución del objeto social de <strong>FinMaq</strong>, los datos personales serán tratados de acuerdo con el grupo de interés y en proporción a la finalidad o finalidades que tenga cada tratamiento, como se describe a continuación:
                </div>


                <div className="ml-10 mt-5 font-semibold">
                    1. Clientes potenciales y clientes:
                </div>

                <div className="ml-16 mt-5">
                    - Verificación de identidad.
                </div>

                <div className="ml-16 mt-3">
                    - Gestionar y ofrecer nuestros productos.
                </div>

                <div className="ml-16 mt-3">
                    - Fines comerciales y de fidelización;
                </div>

                <div className="ml-16 mt-3">
                    - Administración y evaluación de Riesgo
                </div>

                <div className="ml-16 mt-3">
                    - Para el cumplimiento de obligaciones contractuales contraídas, para lo cual, entre otras, podrá recibir llamadas recordatorias o correspondencia escrita o electrónica de la fecha de vencimiento y estado de sus obligaciones. Adicionalmente, <strong>FinMaq</strong> podrá monitorear, grabar y conservar copias de todas las comunicaciones suministradas y recibidas incluyendo, pero sin limitarse a correos electrónicos, llamadas telefónicas y correspondencia postal, todo lo cual será aceptado como prueba válida en un procedimiento judicial.
                </div>

                <div className="ml-16 mt-3">
                    - Realización de análisis estadísticos, comerciales, estratégicos, financieros, sociales y técnicos, entre otros.
                </div>

                <div className="ml-16 mt-3">
                    - Compartir las bases de datos con sociedades subsidiarias, filiales o afiliadas a <strong>FinMaq</strong>, aliados comerciales o a otras sociedades o personas nacionales y/o internacionales que <strong>FinMaq</strong> encargue para realizar el Tratamiento de la información y cumplir con las finalidades descritas en la presente Política, pudiendo ser los Titulares contactados.
                </div>

                <div className="ml-16 mt-3">
                    - En general, para gestionar la información necesaria para el cumplimiento de las obligaciones tributarias, contractuales, comerciales y de registros comerciales, corporativos y contables.
                </div>

                <div className="ml-10 mt-5 font-semibold">
                    2. Garantes:
                </div>

                <div className="ml-16 mt-5">
                    - Verificación de identidad.
                </div>

                <div className="ml-16 mt-3">
                    - Administración y evaluación de Riesgo.
                </div>

                <div className="ml-16 mt-3">
                    - Para el cumplimiento de obligaciones contractuales contraídas, para lo cual, entre otras, podrá recibir llamadas recordatorias o correspondencia escrita o electrónica de la fecha de vencimiento y estado de sus obligaciones. Adicionalmente, <strong>FinMaq S.A.S.</strong> podrá monitorear, grabar y conservar copias de todas las comunicaciones suministradas y recibidas incluyendo, pero sin limitarse a correos electrónicos.
                </div>

                <div className="ml-16 mt-3">
                    - Llamadas telefónicas y correspondencia postal, todo lo cual será aceptado como prueba válida en un procedimiento judicial.
                </div>

                <div className="ml-16 mt-3">
                    - En general, para gestionar la información necesaria para el cumplimiento de las obligaciones tributarias, contractuales, comerciales y de registros comerciales, corporativos y contables.
                </div>

                <div className="ml-10 mt-5 font-semibold">
                    3. Empleados:
                </div>

                <div className="ml-16 mt-5">
                    - Realizar las actividades necesarias para dar cumplimiento a las obligaciones legales en relación con los empleados y ex empleados de <strong>FinMaq</strong>.
                </div>

                <div className="ml-16 mt-3">
                    - Controlar el cumplimiento de requisitos relacionados con el Sistema General de Seguridad Social.
                </div>

                <div className="ml-16 mt-3">
                    - Publicar el directorio corporativo con la finalidad de contacto de los empleados.
                </div>

                <div className="ml-16 mt-3">
                    - Gestionar el proceso Contable de <strong> FinMaq.</strong>
                </div>

                <div className="ml-10 mt-5 font-semibold">
                    4. Proveedores/contratistas:
                </div>

                <div className="ml-16  mt-5">
                    - Para todos los fines relacionados con el objeto de los procesos de selección, contractuales o relacionados con éstos.
                </div>

                <div className="ml-16 mt-3">
                    - Realizar todos los trámites internos y el cumplimiento de obligaciones contables, tributarias y de ley.
                </div>

                <div className="ml-16 mt-3">
                    - Gestionar la emisión de certificados de ingresos y retenciones (personas naturales y jurídicas) y relaciones de pagos.
                </div>

                <div className="ml-16 mt-3">
                    - Gestionar el proceso Contable.
                </div>

                <div className="ml-16 mt-3">
                    - Realizar todas las actividades necesarias para el cumplimiento de las diferentes etapas contractuales en las relaciones con proveedores y contratistas.
                </div>

                <div className="ml-16 mt-3">
                    - Expedir las certificaciones contractuales solicitadas por los contratistas.
                </div>

                <div className="ml-16 mt-3">
                    - Mantener un archivo digital que permita contar con la información correspondiente a cada contrato.
                </div>

                <div className="ml-16 mt-3">
                    - Las demás finalidades que se determinen en procesos de obtención de Datos Personales para su tratamiento, y en todo caso de acuerdo con la Ley y en el marco del objeto social de <strong>FinMaq</strong>.
                </div>
                        
                <div className="text-xl md:p-10 font-bold pb-0">
                    AUTORIZACIÓN DEL TITULAR.
                </div>

                <div className="ml-10 mt-5">
                    Sin perjuicio de las excepciones previstas en la ley, en el Tratamiento se requiere la autorización previa, expresa e informada del Titular, la cual deberá ser obtenida por cualquier medio que pueda ser objeto de consulta posterior.
                </div>

                <div className="ml-10 mt-5">
                    En los casos en que se solicite autorización para el tratamiento de datos personales con finalidades adicionales a aquellas estrictamente necesarias para la celebración del contrato o la prestación del servicio, estas se presentarán de manera diferenciada.
                </div>

                <div className="ml-10 mt-5">
                    <strong>FinMaq</strong> solicitará la autorización presentando al titular las finalidades al menos en dos grupos:
                </div>

                <div className="ml-16 mt-5">
                    <b>1.</b>	Finalidades Necesarias: Aquellas indispensables para la prestación del servicio solicitado (ej. evaluación de riesgo, verificación de identidad, gestión contractual).
                </div>

                <div className="ml-16 mt-3">
                    <b>2.</b>	Finalidades Accesorias: Aquellas que no son esenciales para la prestación del servicio (ej. envío de publicidad, oferta de otros productos, perfilamiento comercial).
                </div>

                <div className="ml-10 mt-5">
                    El titular tiene el derecho a oponerse al tratamiento de sus datos para finalidades accesorias sin que su negativa afecte la continuidad o el acceso al servicio principal.
                </div>

                <div className="ml-10 mt-5">
                    Se entenderá que la autorización cumple con estos requisitos cuando se manifieste <b>(i)</b> por escrito, <b>(ii)</b> de forma oral o <b>(iii)</b> mediante conductas inequívocas del titular que permitan concluir de forma razonable que otorgó la autorización.
                </div>

                <div className="ml-10 mt-5">
                    <strong>Casos en que no es necesaria la autorización:</strong> La autorización del Titular no será necesaria cuando se trate de:
                </div>

                <div className="ml-16 mt-5">
                    - Información requerida por una entidad pública o por orden judicial.
                </div>
               
                <div className="ml-16 mt-3">
                    - Datos de naturaleza pública.
                </div>

                <div className="ml-16 mt-3">
                    - Casos de urgencia médica o sanitaria.
                </div>

                <div className="ml-16 mt-3">
                    - Tratamiento de información autorizado por la ley para fines históricos, estadísticos o científicos.
                </div>

                <div className="ml-16 mt-3">
                    - Datos relacionados con el Registro Civil de las Personas.
                </div>

                <div className="ml-10 mt-5">
                    Quien acceda a los datos personales sin que medie autorización previa deberá en todo caso cumplir con las disposiciones contenidas en la Ley 1581 de 2012 y demás normas concordantes y vigentes.
                </div>
                
                <div className="text-xl md:p-10 font-bold pb-0">
                    SUMINISTRO DE LA INFORMACIÓN.
                </div>

                <div className="ml-10 mt-5">
                    La información solicitada por los Titulares será suministrada principalmente por medios electrónicos, o por cualquier otro solo si así lo requiere el Titular. La información suministrada por <strong>FinMaq</strong> será entregada sin barreras técnicas que impidan su acceso; su contenido será de fácil lectura, acceso y tendrá que corresponder en un todo a aquella que repose en la base de datos.
                </div>

                <div className="text-xl md:p-10 font-bold pb-0">
                    DEBER DE INFORMAR AL TITULAR
                </div>

                <div className="ml-10 mt-5">
                    <b>FinMaq</b>, al momento de solicitar la autorización, informará de manera clara y expresa:
                </div>
                
                <div className="ml-16 mt-5">
                    - El Tratamiento al cual serán sometidos sus datos y su finalidad.
                </div>

                <div className="ml-16 mt-3">
                    - El carácter facultativo de la respuesta a preguntas sobre datos sensibles.
                </div>

                <div className="ml-16 mt-3">
                   - Los derechos que le asisten como Titular.
                </div>

                <div className="ml-16 mt-3">
                    - La identificación, dirección física o electrónica y teléfono del responsable del Tratamiento. <strong>FinMaq</strong> como responsable del Tratamiento, deberá conservar prueba del cumplimiento de lo previsto en el presente numeral y, cuando el Titular lo solicite, entregarle copia de esta.
                </div>
                
                <div className="text-xl md:p-10 font-bold pb-0">
                    PERSONAS A QUIENES SE LES PUEDE SUMINISTRAR LA INFORMACIÓN.
                </div>

                <div className="ml-10 mt-5">
                    La información podrá ser suministrada a:
                </div>

                <div className="ml-16 mt-5">
                    - Los Titulares, sus causahabientes o sus representantes legales.
                </div>

                <div className="ml-16 mt-3">
                    - Las Entidades públicas o administrativas en ejercicio de sus funciones legales o por orden judicial.
                </div>

                <div className="ml-16 mt-3">
                    - Los terceros autorizados por el Titular o por la ley.
                </div>

                <div className="text-xl md:p-10 font-bold pb-0">
                    DEBERES DE FINMAQ COMO RESPONSABLE DEL TRATAMIENTO.
                </div>

                <div className="ml-16 mt-5">
                    - Garantizar al Titular, en todo tiempo, el pleno y efectivo ejercicio del derecho de hábeas data.
                </div>

                <div className="ml-16 mt-3">
                    - Solicitar y conservar copia de la respectiva autorización otorgada por el Titular.
                </div>

                <div className="ml-16 mt-3">
                    - Informar debidamente al Titular sobre la finalidad de la recolección y los derechos que le asisten.
                </div>

                <div className="ml-16 mt-3">
                    - Conservar la información bajo las condiciones de seguridad necesarias para impedir su adulteración, pérdida, consulta, uso o acceso no autorizado o fraudulento.
                </div>

                <div className="ml-16 mt-3">
                    - Garantizar que la información que se suministre a terceros legitimados sea veraz, completa, exacta, actualizada, comprobable y comprensible.
                </div>

                <div className="ml-16 mt-3">
                    - Adoptar las demás medidas necesarias para que la información suministrada a este se mantenga actualizada.
                </div>

                <div className="ml-16 mt-3">
                    - Rectificar la información cuando sea incorrecta.
                </div>

                <div className="ml-16 mt-3">
                    - Tramitar las consultas y reclamos formulados en los términos señalados en la ley.
                </div>

                <div className="ml-16 mt-3">
                    - Adoptar procedimientos específicos para garantizar el adecuado cumplimiento de la ley y en especial, para la atención de consultas y reclamos.
                </div>

                <div className="ml-16 mt-3">
                    - Informar a solicitud del Titular sobre el uso de sus datos.
                </div>

                <div className="ml-16 mt-3">
                    - Informar a la autoridad de protección de datos cuando se presenten violaciones a los códigos de seguridad y existan riesgos en la administración de la información de los Titulares.
                </div>

                <div className="ml-16 mt-3">
                    - Implementar mecanismos sencillos y ágiles, permanentemente disponibles, para el ejercicio de los derechos de los titulares. El procedimiento para la actualización, rectificación y supresión de datos deberá ser igual de ágil que el procedimiento para su recolección.
                </div>

                <div className="ml-16 mt-3">
                    - Abstenerse de contactar, para gestiones de cobranza, a las referencias personales o a las personas en la lista de contactos del dispositivo del titular, salvo que se cuente con la autorización expresa y específica del titular de dichos datos para tal fin.
                </div>

                <div className="ml-16 mt-3">
                    - Formalizar mediante un contrato de transmisión de datos personales toda comunicación de información a un Encargado del tratamiento, definiendo claramente los roles, alcances y obligaciones.
                </div>
                
                <div className="text-xl md:p-10 font-bold pb-0">
                    TRANSFERENCIA Y TRANSMISIÓN INTERNACIONAL DE DATOS PERSONALES
                </div>

                <div className="ml-10 mt-5">
                    Para la prestación de sus servicios, <strong>FinMaq</strong> podrá utilizar infraestructura, plataformas y servicios de proveedores tecnológicos (Encargados del Tratamiento), tales como servicios de computación en la nube (ej. Amazon Web Services, Google Cloud Platform), cuyos servidores pueden estar ubicados físicamente fuera del territorio colombiano.
                </div>

                <div className="ml-10 mt-5">
                    El almacenamiento de datos personales en dichos servidores se considera, para efectos de la ley colombiana, una transmisión internacional de datos personales.
                </div>

                <div className="ml-10 mt-5">
                    Para llevar a cabo estas transmisiones, <strong>FinMaq</strong> se compromete a cumplir con todas las exigencias legales y a garantizar la protección de los datos personales mediante la implementación de las siguientes salvaguardas:
                </div>

                <div className="ml-16 mt-5">
                    <b>1. Verificación del Proveedor</b> Se seleccionarán únicamente proveedores de reconocida trayectoria que ofrezcan garantías suficientes para la protección de la información.
                </div>

                <div className="ml-16 mt-5">
                    <b>2. Formalización Contractual:</b> Se suscribirá un Contrato de Transmisión de Datos Personales con cada proveedor. En el contexto de los servicios en la nube, esto se materializará a través de la aceptación y firma de los Acuerdos de Procesamiento de Datos (DPA - Data Processing Addendum) y/o las Cláusulas Contractuales Tipo (SCC - Standard Contractual Clauses) que ofrezca el proveedor.
                </div>

                <div className="ml-16 mt-5">
                    <b>3. Obligaciones del Encargado:</b> Dichos contratos obligarán al proveedor a tratar los datos personales en nombre de <strong>FinMaq</strong>, a no utilizarlos para fines propios y a implementar medidas de seguridad técnicas y organizativas equivalentes o superiores a las exigidas por la legislación colombiana.
                </div>

                <div className="text-xl md:p-10 font-bold pb-0">
                    ACCIONES GENERALES PARA LA PROTECCIÓN DE DATOS PERSONALES.
                </div>

                <div className="ml-16 mt-5">
                    <b>A) Tratamiento de la información:</b> Todos los empleados asumirán las responsabilidades en el manejo adecuado de la información personal en todo su ciclo de vida. 
                </div>

                <div className="ml-16 mt-5">
                    <b>B) Uso de la información::</b> La información personal se usará solo para las finalidades descritas.
                </div>

                <div className="ml-16 mt-5">
                    <b>C) Almacenamiento de información:</b> El almacenamiento digital y físico se realiza en ambientes con controles adecuados.
                </div>

                <div className="ml-16 mt-5">
                    <b>D) Destrucción:</b> La destrucción de medios se realiza con mecanismos que no permiten su reconstrucción, dejando trazabilidad y cumpliendo la normativa.
                </div>

                <div className="text-xl md:p-10 font-bold pb-0">
                    PROCEDIMIENTO DE GESTIÓN DE INCIDENTES CON DATOS PERSONALES.
                </div>

                <div className="ml-10 mt-5">
                    Se entiende por incidencia cualquier anomalía que afecte la seguridad de las bases de datos. Todo empleado debe reportar cualquier evento sospechoso o incidente. Se realizarán actividades de notificación, gestión, identificación, contención, investigación, solución y cierre de incidentes.  
                </div>

                <div className="ml-16 mt-5 font-bold">
                    Fase 1: Detección y Reporte Inmediato  
                </div>

                <div className="ml-24 mt-5">
                    <b>1. Identificación:</b> Cualquier empleado, tercero o área que detecte una actividad inusual, una posible brecha de seguridad o una vulnerabilidad que pueda afectar datos personales, debe considerarlo un potencial incidente.
                </div>

                <div className="ml-24 mt-3">
                    <b>2. Reporte Obligatorio:</b> El evento debe ser reportado de manera inmediata a través del canal oficial: el correo electrónico <a className="font-bold" href="mailto:segurinfo@finmaq.com.co">segurinfo@finmaq.com.co</a>.
                </div>

                <div className="ml-16 mt-5 font-bold">
                    Fase 2: Evaluación y Activación del CSIRT
                </div>

                <div className="ml-24 mt-5">
                    <b>1. Triage y Clasificación:</b> El Oficial de Seguridad de la Información (CISO) recibirá y evaluará el reporte para confirmar si constituye un incidente y determinará su nivel de severidad.
                </div>

                <div className="ml-24 mt-3">
                    <b>2. Activación del CSIRT:</b> Si se confirma un incidente, se activará el <strong>Equipo de Respuesta a Incidentes de Seguridad Informática (CSIRT)</strong>. Este equipo tendrá una composición multidisciplinaria, liderada por el CISO e integrada por personal clave de:
                </div>

                <div className="ml-32 mt-5">
                    - <b>Área Técnica (TI y Seguridad):</b> Para la respuesta técnica y forense.
                </div>

                <div className="ml-32 mt-5">
                    - <b>Área Legal y de Cumplimiento:</b> Para evaluar el impacto legal, regulatorio y la necesidad de notificaciones.
                </div>

                <div className="ml-32 mt-5">
                    - <b>Área de Comunicaciones:</b> Para gestionar la comunicación con clientes, medios u otras partes interesadas, si fuera necesario.
                </div>

                <div className="ml-32 mt-5">
                    - <b>Líderes de las áreas de negocio afectadas.</b>
                </div>

                <div className="ml-16 mt-5 font-bold">
                    Fase 3: Contención
                </div>

                <div className="ml-24 mt-5">
                    <b>1. Acciones Inmediatas:</b> El <strong>CSIRT</strong> ejecutará las acciones necesarias para contener el incidente y evitar que se propague (ej. aislar sistemas, revocar credenciales, etc.).
                </div>

                <div className="ml-16 mt-5 font-bold">
                    Fase 4: Investigación y Análisis
                </div>

                <div className="ml-24 mt-5">
                    <b>1. Análisis Forense:</b> El componente técnico del <strong>CSIRT</strong> realizará una investigación para determinar la causa raíz del incidente y el alcance del compromiso.
                </div>

                <div className="ml-24 mt-5">
                    <b>2. Documentación:</b> Todo el proceso se documentará rigurosamente, preservando la cadena de custodia de las evidencias.
                </div>

                <div className="ml-16 mt-5 font-bold">
                    Fase 5: Notificación y Comunicación
                </div>

                <div className="ml-24 mt-5">
                    <b>1. Notificación a la Autoridad:</b> El componente legal del <strong>CSIRT</strong> evaluará la obligación de notificar a la Superintendencia de Industria y Comercio (SIC). De ser necesario, el Representante Legal realizará dicha notificación.
                </div>

                <div className="ml-24 mt-5">
                    <b>2. Comunicación a los Titulares:</b> El <strong>CSIRT</strong> en pleno evaluará la necesidad de comunicar el incidente a los titulares afectados.
                </div>

                <div className="ml-16 mt-5 font-bold">
                    Fase 6: Erradicación, Recuperación y Lecciones Aprendidas
                </div>

                <div className="ml-24 mt-5">
                    <b>1. Erradicación y Recuperación:</b> Se eliminará la causa raíz y se restaurarán los sistemas a un estado operativo seguro.
                </div>

                <div className="ml-24 mt-5">
                    <b>2. Post-Incidente:</b> El <strong>CSIRT</strong> realizará una reunión de lecciones aprendidas para identificar fallas y oportunidades de mejora, que se traducirán en un plan de acción para fortalecer nuestros controles.
                </div>

                <div className="text-xl md:p-10 font-bold pb-0">
                    ATENCIÓN A PETICIONES, CONSULTAS Y RECLAMOS.
                </div>

                <div className="ml-10 mt-5">
                    Las PQR de los titulares para ejercer sus derechos deberán dirigirse a los siguientes canales:
                </div>

                <div className="ml-16 mt-3">
                    - Dirección física: Carrera 10 # 97a - 13 Bogotá D.C.
                </div>

                <div className="ml-16 mt-3">
                    - Correo electrónico: <a className="font-bold" href="mailto:protecciondedatos@finmaq.com.co">protecciondedatos@finmaq.com.co</a>
                </div>

                <div className="text-xl md:p-10 font-bold pb-0">
                    PROCEDIMIENTO PARA ATENDER LOS DERECHOS DE LOS TITULARES.
                </div>

                <div className="ml-10 mt-5">
                    Todo titular de datos personales tiene derecho a presentar consultas y reclamos para ejercer sus derechos de conocer, actualizar, rectificar y suprimir sus datos, o revocar su autorización. Para ello, <strong>FinMaq</strong> establece el siguiente procedimiento claro y accesible:
                </div>

                <div className="ml-10 mt-5">
                    <strong>Paso 1: Presentación de la Solicitud (Cliente/Titular)</strong> El titular o su representante legal deberá enviar su solicitud a través de uno de nuestros canales oficiales:
                </div>

                <div className="ml-16 mt-5">
                    - Dirección física: Carrera 10 # 97a - 13 Bogotá D.C.
                </div>

                <div className="ml-16 mt-3">
                    - Correo electrónico: <a className="font-bold" href="mailto:protecciondedatos@finmaq.com.co">protecciondedatos@finmaq.com.co</a>
                </div>

                <div className="ml-10 mt-5">
                    Para una gestión eficiente, la solicitud deberá contener como mínimo:
                </div>

                <div className="ml-16 mt-5">
                    - Nombre completo y apellidos.
                </div>
                
                <div className="ml-16 mt-3">
                    - Número del documento de identificación.
                </div>
                
                <div className="ml-16 mt-3">
                    - Descripción clara y precisa de la consulta o reclamo.
                </div>
                
                <div className="ml-16 mt-3">
                    - Dirección física o correo electrónico para recibir la respuesta.
                </div>

                <div className="ml-10 mt-5">
                    <strong>Paso 2: Radicación y Acuse de Recibo (FinMaq)</strong> Una vez recibida la solicitud, FinMaq generará un número de radicado y enviará un acuse de recibo al titular en un plazo no mayor a dos (2) días hábiles, confirmando que su solicitud está en trámite.
                </div>

                <div className="ml-10 mt-5 font-bold">
                    Paso 3: Verificación y Subsanación (FinMaq)
                </div>

                <div className="ml-16 mt-5">
                    <b>1.	Verificación de Identidad:</b> FinMaq validará la identidad del solicitante para asegurar la protección de los datos.
                </div>

                <div className="ml-16 mt-3">
                    <b>2.	Requerimiento de Información:</b> Si la solicitud está incompleta, se requerirá al titular dentro de los cinco (5) días hábiles siguientes a la recepción para que subsane las fallas.
                </div>

                <div className="ml-16 mt-3">
                    <b>3.	Desistimiento:</b> Si el titular no presenta la información requerida transcurrido un (1) mes desde la fecha del requerimiento, se entenderá que ha desistido de su solicitud.
                </div>

                <div className="ml-10 mt-5">
                    <strong>Paso 4: Respuesta Final (FinMaq) FinMaq</strong> gestionará internamente la solicitud y dará una respuesta definitiva al titular, cumpliendo con los siguientes plazos legales:
                </div>

                <div className="ml-16 mt-5">
                    -<b> Para Consultas:</b> El término máximo para atender la consulta será de <b>diez (10) días hábiles</b>. Si no es posible atenderla en este tiempo, se informará al titular, expresando los motivos de la demora y señalando la fecha en que se atenderá, la cual no superará los <b>cinco (5) días hábiles</b> siguientes al vencimiento del primer término.
                </div>

                <div className="ml-16 mt-3">
                    -<b> Para Reclamos (Corrección, supresión, etc.):</b> El término máximo para atender el reclamo será de <b>quince (15) días hábiles</b>. Si no es posible atenderlo en este tiempo, se informará al titular los motivos de la demora y la fecha de respuesta, la cual no superará los <b>ocho (8) días hábiles</b> siguientes al vencimiento del primer término.
                </div>

                <div className="ml-10 mt-5">
                    La respuesta final se enviará al medio de contacto (correo electrónico o dirección física) proporcionado por el titular en su solicitud inicial.
                </div>

                <div className="text-xl md:p-10 font-bold pb-0">
                    SENSIBILIZACIÓN, AUDITORÍAS Y VIGENCIA.
                </div>

                <div className="ml-16 mt-5">
                    - <b>Sensibilización: FinMaq</b> desarrollará programas periódicos de sensibilización y concientización.
                </div>

                <div className="ml-16 mt-3">
                    - <b>Auditorías:</b> Se realizarán auditorías periódicas para verificar la implementación de esta política.
                </div>

                <div className="ml-16 mt-3">
                    - <b>Vigencia de las Bases de Datos:</b> Tendrán la vigencia correspondiente a la finalidad de su tratamiento y a los términos legales de conservación.
                </div>

                <div className="ml-16 mt-3 mb-32">
                    - <b>Vigencia de la Política:</b> La presente política rige a partir de su publicación. Cualquier cambio sustancial será comunicado oportunamente a los titulares.
                </div>
                <hr/>
            </div>
            <Footer/>
        </div>
    )
}